import { render, staticRenderFns } from "./SlideSelectSerial.vue?vue&type=template&id=65859840&scoped=true"
import script from "./SlideSelectSerial.vue?vue&type=script&lang=js"
export * from "./SlideSelectSerial.vue?vue&type=script&lang=js"
import style0 from "./SlideSelectSerial.vue?vue&type=style&index=0&id=65859840&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65859840",
  null
  
)

export default component.exports